import React, { useEffect, useState } from "react";
import { Dialog } from "@headlessui/react";
import { Formik, Field, Form, useFormikContext, ErrorMessage } from "formik";
import styles from "./EventGuestList.module.css";
import { useUser } from "@hooks/Auth/useUser";
import PhoneInput, { isValidPhoneNumber } from "react-phone-number-input";
import "react-phone-number-input/style.css";
import * as Yup from "yup";
import { createGuestlistPayment } from "@services/paymentAPI";
import VerifyEmail from "@components/VerifyEmail/VerifyEmail";
import { usePathname, useRouter } from "next/navigation";
import InputNumber from "./inputs";
import { Spinner } from "@components/Spinner/Spinner";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { FiAlertCircle } from "react-icons/fi";
import GuestListPayment from "./GuestListPayment";
import { FaFacebook, FaInstagram, FaTwitter } from "react-icons/fa";
import VerifyPhoneDialog from "@components/VerifyPhone/verifyDialog";
import config from "@config/config";

// Refactored PhoneInputField: uses Formik state & Yup validation errors
const PhoneInputField = ({ field, form }) => {
  return (
    <div className={styles.phone_input}>
      <PhoneInput
        {...field}
        country="US"
        value={field.value}
        onChange={(value) => {
          form.setFieldValue(field.name, value, true);
        }}
      />
      {form.touched[field.name] && form.errors[field.name] && (
        <div style={{ color: "red" }}>{form.errors[field.name]}</div>
      )}
    </div>
  );
};

const WhatsAppPhoneInputField = ({ field, form }) => {
  return (
    <div className={styles.phone_input}>
      <PhoneInput
        {...field}
        country="US"
        value={field.value}
        onChange={(value) => {
          form.setFieldValue(field.name, value, true);
        }}
      />
      {form.touched[field.name] && form.errors[field.name] && (
        <div style={{ color: "red" }}>{form.errors[field.name]}</div>
      )}
    </div>
  );
};

const EventGuestLists = ({ guestlists, event, controlNav }) => {
  // States and local variables
  const [isOpen, setIsOpen] = useState(false);
  const [checkout, setCheckout] = useState(false);
  const [loading, setLoading] = useState(false);
  const [success, setSuccess] = useState(false);
  const [error, setError] = useState(false);
  const [errorMsg, setErrorMsg] = useState("");
  const [successMsg, setSuccessMsg] = useState("");
  const [currentGuestList, setCurrentGuestList] = useState({});
  const [gatewayData, setGatewayData] = useState({});
  const [gateway, setGateway] = useState("");
  const [orderData, setOrderData] = useState({});
  const [guestCount, setGuestCount] = useState(1);
  const [maleValue, setMaleValue] = useState(0);
  const [femaleValue, setFemaleValue] = useState(0);
  const [othersValue, setOthersValue] = useState(0);
  const [newMinNull, setNewMinNull] = useState();
  const [newMin, setNewMin] = useState(0);
  const [newMax, setNewMax] = useState(0);
  const { user } = useUser();
  const router = useRouter();
  const pathname = usePathname();
  const [redirectUrl, setRedirectUrl] = useState(pathname);

  // These variables are used in the onSubmit block
  let primaryGuest = {};
  let expectedGuests = {};
  let socialLinks = {};

  const getMaxDate = () => {
    const today = new Date();
    const maxDate = new Date(
      today.getFullYear() - 18,
      today.getMonth(),
      today.getDate()
    );
    return maxDate.toISOString().split("T")[0];
  };

  function handleDateChange(event, setFieldValue) {
    const selectedDate = event.target.value;
    setFieldValue("dob", selectedDate);
  }

  const [openVerifyPhone, setOpenVerifyPhone] = useState(false);
  const closeVerification = (phones) => {
    setOpenVerifyPhone(false);
    setPhone(phones);
  };

  // Set initial values from the user data
  const [initials, setInitials] = useState({
    firstName: user?.fname || "",
    lastName: user?.lastName || "",
    email: user?.email || "",
    phoneNumber: user?.phoneNumber || "",
    dob: user?.dob || "",
    gender: user?.gender || "male",
    male: 0,
    female: 0,
    others: 0,
    link1: "",
    link2: "",
    link3: "",
    userNote: "",
    guestCount,
    whatsappPhoneNumber: "",
    referral: "",
  });

  useEffect(() => {
    setInitials({
      firstName: user?.fname || "",
      lastName: user?.lastName || "",
      email: user?.email || "",
      phoneNumber: user?.phoneNumber || "",
      dob: user?.dob || "",
      gender: user?.gender || "male",
      male: 0,
      female: 0,
      others: 0,
      link1: "",
      link2: "",
      link3: "",
      userNote: "",
      guestCount,
      whatsappPhoneNumber: "",
      referral: "",
    });
  }, [user]);

  const deleteSavedPromoterData = () => {
    if (typeof window !== "undefined") {
      localStorage.removeItem("promoterData");
    }
  };
  const handleLeftGuests = () => {
    if (currentGuestList) {
      if (newMinNull === null) {
        return "(no limit)";
      } else {
        if (guestCount - 1 < newMin) {
          return `(From ${newMin - 1} to ${
            newMax > 998 ? "no limit" : newMax - 1
          } guests allowed)`;
        }
        if (guestCount - 1 >= newMin && guestCount - 1 <= newMax) {
          return `(From ${newMin - 1} to ${
            newMax > 998 ? "no limit" : newMax - 1
          } guests allowed) `;
        } else {
          return `(From ${newMin - 1} to ${
            newMax > 998 ? "no limit" : newMax - 1
          } guests allowed) `;
        }
      }
    }
  };
  const title = "LISTS"
  return (
    <div className={styles.wrapper}>
      {event.eventID === "Ug0ewdFpIqDxuLR4a8YW" ? <h2></h2> : <h2>LISTS</h2>}
      {guestlists.map((guestlist, index) => (
        <div className={styles.guestlist} key={index}>
          <span className={styles.name}>{guestlist.name}</span>
          <button
            className={styles.button}
            onClick={() => {
              setSuccess(false);
              setCheckout(false);
              setIsOpen(true);
              if (guestlist?.requestSettings?.minGuests === null) {
                setNewMinNull(null);
                setNewMin(0);
              } else {
                setNewMin(guestlist?.requestSettings?.minGuests);
                setNewMinNull(0);
              }
              if (guestlist?.requestSettings?.maxGuests === null)
                setNewMax(999);
              else setNewMax(guestlist?.requestSettings?.maxGuests);
              setCurrentGuestList(guestlist);
            }}
          >
            {event.eventID !== "5MygJUf6VZZv3eBJZ4OX" ? "Join" : "Take part"}
          </button>
        </div>
      ))}

      <Dialog
        open={isOpen}
        onClose={() => setIsOpen(false)}
        className={styles.dialog_wrapper}
      >
        <Dialog.Panel className={styles.panel}>
          {true ? (
            checkout ? (
              <GuestListPayment
                closeDialog={() => setIsOpen(false)}
                event={event}
                guestList={currentGuestList}
                guestInfo={{
                  primaryGuest,
                  expectedGuests,
                  socialLinks,
                  maleValue,
                  femaleValue,
                  othersValue,
                }}
                gatewayData={gatewayData}
                gateway={gateway}
                orderData={orderData}
              />
            ) : (
              <div className={styles.panel_wrapper}>
                <div className={styles.panel_header}>
                  <h3 className={styles.titleText}>
                    Request to join guestlists group
                  </h3>
                  <button
                    className={styles.closeButton}
                    onClick={() => setIsOpen(false)}
                  >
                    &times;
                  </button>
                </div>
                <h4 className={styles.free}>
                  {currentGuestList.isPaid
                    ? `${currentGuestList.basePrice} ${currentGuestList.currency} per guest`
                    : event.eventID === "A5D7aWyoiCu5Oe9EfKtT"
                    ? ""
                    : "Free"}
                </h4>
                <h4 style={{ lineHeight: "20px" }}>
                  {currentGuestList.publicNote}
                </h4>
                <h4>Personal Info</h4>
                <Formik
                  enableReinitialize={true}
                  initialValues={initials}
                  validationSchema={Yup.object().shape({
                    firstName: Yup.string().required("First Name is required"),
                    lastName: Yup.string().required("Last Name is required"),
                    email: Yup.string()
                      .email("Invalid email")
                      .required("Email is required"),
                    phoneNumber: Yup.string()
                      .required("Phone Number is required")
                      .test(
                        "isValidPhoneNumber",
                        "Invalid phone number",
                        (value) => isValidPhoneNumber(value || "")
                      ),
                    dob: Yup.date().required("Date of Birth is required"),
                  })}
                  onSubmit={async (values, { setFieldError }) => {
                    // Since Yup is handling the phone validation,
                    // we no longer need manual phone checks here.
                    const {
                      firstName,
                      lastName,
                      email,
                      phoneNumber,
                      dob,
                      gender,
                      link1,
                      link2,
                      link3,
                      userNote,
                      whatsappPhoneNumber,
                      referral,
                    } = values;

                    primaryGuest = {
                      firstName,
                      lastName,
                      email,
                      phoneNumber: user.phoneNumber ?? phoneNumber,
                      dob,
                      gender,
                    };

                    const male1 = parseInt(maleValue);
                    const female1 = parseInt(femaleValue);
                    const others1 = parseInt(othersValue);

                    expectedGuests = {
                      male: male1,
                      female: female1,
                      other: others1,
                    };
                    socialLinks = {
                      instagram: link1,
                      facebook: link2,
                      twitter: link3,
                    };

                    if (
                      currentGuestList &&
                      currentGuestList.requestSettings.isIndividual === false &&
                      male1 + female1 + others1 + 1 < newMin
                    ) {
                      setError(true);
                      setErrorMsg(
                        `From ${newMin - 1} to ${newMax - 1} guests allowed`
                      );
                      return;
                    }
                    if (
                      currentGuestList &&
                      currentGuestList.requestSettings.isIndividual === false &&
                      male1 + female1 + others1 + 1 > newMax
                    ) {
                      setError(true);
                      setErrorMsg(
                        `You exceed the limit by ${Math.abs(
                          newMax - (male1 + female1 + others1 + 1)
                        )}`
                      );
                      return;
                    }

                    setLoading(true);
                    try {
                      let promoterParam = "";
                      if (typeof window !== "undefined") {
                        const savedPromoterData =
                          localStorage.getItem("promoterData");
                        if (savedPromoterData) {
                          try {
                            const promoterData = JSON.parse(savedPromoterData);
                            if (promoterData.eventId === event.eventID) {
                              promoterParam = promoterData.promoter;
                            }
                          } catch (error) {
                            console.error(
                              "Error parsing promoterData from localStorage",
                              error
                            );
                          }
                        }
                      }
                      const session = await createGuestlistPayment(
                        event.eventID,
                        currentGuestList.listID,
                        "card",
                        "authorization",
                        "request",
                        primaryGuest,
                        expectedGuests,
                        socialLinks,
                        "tickit.co",
                        `${config.BASE_URL}/receipt/`,
                        `${config.BASE_URL}/receipt/?type=guestlist`,
                        `${config.BASE_URL}/receipt/?type=guestlist`,
                        `${config.BASE_URL}/events/${event.eventID}`,
                        userNote ?? "",
                        whatsappPhoneNumber ?? "",
                        referral ?? "",
                        promoterParam
                      );
                      if (
                        session.status === "success" &&
                        currentGuestList.isPaid
                      ) {
                        setGatewayData(session.data.gatewayData);
                        setOrderData(session.data.orderData);
                        setGateway(session.data.gateway);
                        if (session.data.gateway === "whish") {
                          window.location.href =
                            session.data.gatewayData.whishPaymentUrl;
                          return;
                        }
                        if (session.data.gateway === "network") {
                          window.location.href =
                            session.data.gatewayData.paymentUrl;
                          return;
                        }
                        setCheckout(true);
                        setLoading(false);
                        return;
                      }
                      if (
                        session.status === "success" &&
                        !currentGuestList.isPaid
                      ) {
                        setMaleValue(0);
                        setFemaleValue(0);
                        setOthersValue(0);
                        setLoading(false);
                        setSuccessMsg(
                          "Your request to join the guest list group has been submitted successfully! 🎉"
                        );
                        deleteSavedPromoterData();
                        setSuccess(true);
                        return;
                      } else {
                        setError(true);
                      }
                    } catch (error) {
                      setErrorMsg(error.response.data.message);
                      setError(true);
                      setLoading(false);
                    }
                    setLoading(false);
                  }}
                >
                  {({ isSubmitting, setFieldValue, values, touched, errors }) => (
                    <Form className={styles.fullForm}>
                      {success && (
                        <VerifyEmail
                          title="GuestList"
                          message={successMsg}
                          success={true}
                          onVerified={() => setIsOpen(false)}
                        />
                      )}
                      {error && (
                        <VerifyEmail
                          title="GuestList"
                          message={errorMsg}
                          success={false}
                          onVerified={() => {
                            setError(false);
                          }}
                        />
                      )}
                      <div className={styles.panel_form}>
                        <Field
                          type="text"
                          name="firstName"
                          placeholder="First Name"
                          className={
                            touched.firstName && errors.firstName
                              ? `vibrating-input ${styles.errorInput}`
                              : ""
                          }
                        />
                        <Field
                          type="text"
                          name="lastName"
                          placeholder="Last Name"
                          className={
                            touched.lastName && errors.lastName
                              ? `vibrating-input ${styles.errorInput}`
                              : ""
                          }
                        />
                        <Field
                          type="text"
                          name="email"
                          placeholder="Email"
                          className={
                            touched.email && errors.email
                              ? `vibrating-input ${styles.errorInput}`
                              : ""
                          }
                        />
                        <Field name="phoneNumber" component={PhoneInputField} />
                        <div className={styles.dobPicker}>
                          <Field
                            type="date"
                            id="dob"
                            name="dob"
                            max={getMaxDate()}
                            onChange={(e) => handleDateChange(e, setFieldValue)}
                            className={
                              touched.dob && errors.dob
                                ? `vibrating-input ${styles.errorInput}`
                                : ""
                            }
                          />
                          <ErrorMessage
                            name="dob"
                            component="div"
                            className="error"
                          />
                        </div>
                        <Field as="select" name="gender" className={styles.gender}>
                          <option value="male">Male</option>
                          <option value="female">Female</option>
                          <option value="other">Other</option>
                        </Field>
                      </div>
                      <div className={styles.newInputsP}>
                        <div className={styles.newInputs1}>
                          WhatsApp Phone Number:
                        </div>
                        <div className={styles.newInputs2}>
                          <Field
                            name="whatsappPhoneNumber"
                            component={WhatsAppPhoneInputField}
                          />
                        </div>
                        <div className={styles.newInputs3}>Who referred you?</div>
                        <div className={styles.newInputs4}>
                          <Field
                            type="text"
                            name="referral"
                            placeholder="Referral"
                            className={
                              touched.referral && errors.referral
                                ? `vibrating-input ${styles.errorInput}`
                                : ""
                            }
                          />
                        </div>
                      </div>
                      <p>
                        <b>Note:</b> The organizer will have to reach you through WhatsApp
                      </p>
                      {!currentGuestList.requestSettings.isIndividual && (
                        <>
                          <h4>
                            My Guests &nbsp;
                            {handleLeftGuests()}
                          </h4>
                          <div className={styles.numbers}>
                            <div className={styles.all}>
                              <div className={`${styles.titleNumbers} ${styles.maleTitle}`}>
                                <div>Males: </div>
                                <div className={styles.InputNumbers}>
                                  <button
                                    type="button"
                                    onClick={() => {
                                      if (maleValue > 0) {
                                        setMaleValue(maleValue - 1);
                                        setGuestCount(guestCount - 1);
                                      }
                                    }}
                                  >
                                    &minus;
                                  </button>
                                  <span>{maleValue}</span>
                                  <button
                                    type="button"
                                    onClick={() => {
                                      setMaleValue(maleValue + 1);
                                      setGuestCount(guestCount + 1);
                                    }}
                                  >
                                    &#43;
                                  </button>
                                </div>
                              </div>
                              <div className={styles.titleNumbers}>
                                <div>Females: </div>
                                <div className={`${styles.InputNumbers} ${styles.females}`}>
                                  <button
                                    type="button"
                                    onClick={() => {
                                      if (femaleValue > 0) {
                                        setFemaleValue(femaleValue - 1);
                                        setGuestCount(guestCount - 1);
                                      }
                                    }}
                                  >
                                    &minus;
                                  </button>
                                  <span>{femaleValue}</span>
                                  <button
                                    type="button"
                                    onClick={() => {
                                      setFemaleValue(femaleValue + 1);
                                      setGuestCount(guestCount + 1);
                                    }}
                                  >
                                    &#43;
                                  </button>
                                </div>
                              </div>
                              <div className={`${styles.titleNumbers} ${styles.otherTitle}`}>
                                <div>Others: </div>
                                <div className={`${styles.InputNumbers} ${styles.others}`}>
                                  <button
                                    type="button"
                                    onClick={() => {
                                      if (othersValue > 0) {
                                        setOthersValue(othersValue - 1);
                                        setGuestCount(guestCount - 1);
                                      }
                                    }}
                                  >
                                    &minus;
                                  </button>
                                  <span>{othersValue}</span>
                                  <button
                                    type="button"
                                    onClick={() => {
                                      setOthersValue(othersValue + 1);
                                      setGuestCount(guestCount + 1);
                                    }}
                                  >
                                    &#43;
                                  </button>
                                </div>
                              </div>
                            </div>
                          </div>
                        </>
                      )}
                      <div>
                        <h4>
                          Social Links{" "}
                          <small className={styles.small}>(Recommended)</small>
                        </h4>
                        <div className={styles.text}>
                          <div className={styles.socials}>
                            <FaInstagram />
                            <Field type="text" name="link1" placeholder="Instagram" />
                          </div>
                          <div className={styles.socials}>
                            <FaFacebook />
                            <Field type="text" name="link2" placeholder="Facebook" />
                          </div>
                          <div className={styles.socials}>
                            <FaTwitter />
                            <Field type="text" name="link3" placeholder="Twitter" />
                          </div>
                        </div>
                      </div>
                      <div className={`${styles.text} ${styles.text1}`}>
                        <h4>Write a note to the Organizers</h4>
                        <Field
                          as="textarea"
                          name="userNote"
                          placeholder="Write your note here..."
                          className={styles.noteField}
                        />
                      </div>
                      <div className={styles.border}></div>
                      <div className={styles.end}>
                        <div className={styles.column}>
                          <span>
                            {maleValue + femaleValue + othersValue + 1} Guests
                          </span>
                          <span className={styles.free}>
                            {currentGuestList.isPaid
                              ? `${currentGuestList.basePrice *
                                  (maleValue + femaleValue + othersValue + 1)} ${currentGuestList.currency}`
                              : event.eventID === "A5D7aWyoiCu5Oe9EfKtT"
                              ? ""
                              : "Free"}
                          </span>
                          {currentGuestList.isPaid && (
                            <div
                              className={styles.row}
                              style={{
                                alignItems: "center",
                                display: "flex",
                                justifyContent: "flex-start",
                                opacity: "80%",
                              }}
                            >
                              <FiAlertCircle /> &nbsp;{" "}
                              <span>Excluding Service Fees</span>
                            </div>
                          )}
                        </div>
                        <button
                          type="submit"
                          disabled={isSubmitting}
                          className={styles.submit}
                        >
                          {loading ? (
                            <div style={{ padding: "3px" }}>
                              <Spinner />
                            </div>
                          ) : currentGuestList.isPaid ? (
                            "Checkout"
                          ) : (
                            "Submit"
                          )}
                        </button>
                      </div>
                    </Form>
                  )}
                </Formik>
              </div>
            )
          ) : (
            <VerifyPhoneDialog
              phoneNumber={true}
              event={event}
              closeVerification={closeVerification}
            />
          )}
        </Dialog.Panel>
      </Dialog>
    </div>
  );
};

export default EventGuestLists;
